import { render, staticRenderFns } from "./form4.vue?vue&type=template&id=1f060fa2&scoped=true&"
import script from "./form4.vue?vue&type=script&lang=js&"
export * from "./form4.vue?vue&type=script&lang=js&"
import style0 from "./form4.vue?vue&type=style&index=0&id=1f060fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f060fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f060fa2')) {
      api.createRecord('1f060fa2', component.options)
    } else {
      api.reload('1f060fa2', component.options)
    }
    module.hot.accept("./form4.vue?vue&type=template&id=1f060fa2&scoped=true&", function () {
      api.rerender('1f060fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/activityForm/components/form4.vue"
export default component.exports